import { AMLS_TM_IAD } from './globalConstants';

const TOKEN_ID = (localStorage && localStorage.getItem('id_token')) || '';
const PRODUCT_ID = (localStorage && localStorage.getItem('productId')) || '';

export const TRM_CONSTANTS = {
  TRM_BASE_URL: AMLS_TM_IAD,
  HTTP_HEADERS: Object.freeze({
    'Content-Type': 'application/json',
    'X-HTTP-Method-Override': 'PUT',
    // Authorization: `${TOKEN_ID}`,
    Authorization: `Bearer ${TOKEN_ID}`,
    ProductId: PRODUCT_ID
  }),
  GET_SUCCESS_DATA: 'getSuccessData',
  GET_FAILURE_DATA: 'getFailData',
  GET_DATA: 'getData',
  YET_TO_START: 'Yet to Start',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  IN_QUEUE: 'InQueue',
  YES: 'Yes',
  NO: 'No'
};

export const TM_IAD_TAB_LIST = ['TM IAD'];
export const TM_IAD_TAB_PAGEID_LIST = ['TM_IAD_ALERTS_DETAILS'];
export const CUSTOMER_MATCHING_TABL_LIST = ['Create New Set'];
export const TM_IAD_TAB_MODULE_ID = '3';
export const TM_IAD_TAB_SUBMODULE = 'global';
export const TM_IAD_TAB_MODULE_NAME = 'TM-IAD';

export const FRAUD_IAD_TAB_LIST = ['Fraud'];
export const FRAUD_IAD_TAB_PAGEID_LIST = ['FRAUD_IAD_ALERTS_DETAILS'];

export const TM_FRAUD_IAD_TAB_LIST = ['TM IAD', 'Fraud'];
export const TM_FRAUD_IAD_TAB_PAGEID_LIST = [
  'TM_IAD_ALERTS_DETAILS',
  'FRAUD_IAD_ALERTS_DETAILS'
];

export const TRM_BASE_ROUTE = '/app/trm';
